import React, { useState } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';

import { 
    Row, 
    Col, 
    Card, 
    CardBody, 
    CardHeader, 
    Input, 
    InputGroup,
    InputGroupText,
    Label, 
    Button,
    Badge,
    Alert,
    Spinner
} from 'reactstrap';

import { 
    FaPlusCircle, 
    FaEye, 
    FaFilePdf, 
    FaSearch,
    FaShoppingCart,
    FaShoppingBag,
    FaRupeeSign,
    FaCalendarAlt,
    FaHashtag,
    FaDownload,
    FaFilter
} from 'react-icons/fa';

import InputSale from '../../component/utility/setting/InputSale';
import InputPurchase from '../../component/utility/setting/InputPurchase';

const InputSalePurchase = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [frDate, setFrDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filterType, setFilterType] = useState('all');
    const [tableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const get_sale_purchase_list = () => {
        setLoading(true);
        
        // Simulate API call
        setTimeout(() => {
            let list = [
                {
                    sl: 1,
                    trans_id: "SH1001",
                    trans_type: "Sale",
                    date: "04-02-2023",
                    amt: 1370.00,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18}/>,
                    action: <FaEye className='cursor-pointer text-warning' size={18} />,
                    rawData: { id: "SH1001", type: "Sale", amount: 1370.00 }
                },
                {
                    sl: 2,
                    trans_id: "SH1002",
                    trans_type: "Sale",
                    date: "03-02-2023",
                    amt: 2370.00,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18}/>,
                    action: <FaEye className='cursor-pointer text-warning' size={18} />,
                    rawData: { id: "SH1002", type: "Sale", amount: 2370.00 }
                },
                {
                    sl: 3,
                    trans_id: "PH1002",
                    trans_type: "Purchase",
                    date: "03-02-2023",
                    amt: 870.00,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18}/>,
                    action: <FaEye className='cursor-pointer text-warning' size={18} />,
                    rawData: { id: "PH1002", type: "Purchase", amount: 870.00 }
                },
                {
                    sl: 4,
                    trans_id: "SH1006",
                    trans_type: "Purchase",
                    date: "03-02-2023",
                    amt: 1070.00,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18}/>,
                    action: <FaEye className='cursor-pointer text-warning' size={18} />,
                    rawData: { id: "SH1006", type: "Purchase", amount: 1070.00 }
                },
                {
                    sl: 5,
                    trans_id: "SH1007",
                    trans_type: "Sale",
                    date: "02-02-2023",
                    amt: 1850.00,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18}/>,
                    action: <FaEye className='cursor-pointer text-warning' size={18} />,
                    rawData: { id: "SH1007", type: "Sale", amount: 1850.00 }
                },
                {
                    sl: 6,
                    trans_id: "PH1003",
                    trans_type: "Purchase",
                    date: "01-02-2023",
                    amt: 1250.00,
                    invoice: <FaFilePdf className='cursor-pointer text-danger' size={18}/>,
                    action: <FaEye className='cursor-pointer text-warning' size={18} />,
                    rawData: { id: "PH1003", type: "Purchase", amount: 1250.00 }
                }
            ];
            setTableData(list);
            setFilteredData(list);
            setLoading(false);
        }, 1000);
    };

    // Enhanced search and filter functionality
    const handleSearch = (value) => {
        setSearchTerm(value);
        applyFilters(value, filterType);
    };

    const handleFilterType = (type) => {
        setFilterType(type);
        applyFilters(searchTerm, type);
    };

    const applyFilters = (search, type) => {
        let filtered = tableData;

        // Apply type filter
        if (type !== 'all') {
            filtered = filtered.filter(item => 
                item.trans_type.toLowerCase() === type.toLowerCase()
            );
        }

        // Apply search filter
        if (search) {
            filtered = filtered.filter(item =>
                item.trans_id.toLowerCase().includes(search.toLowerCase()) ||
                item.trans_type.toLowerCase().includes(search.toLowerCase()) ||
                item.date.includes(search)
            );
        }

        setFilteredData(filtered);
    };

    // Calculate statistics
    const getStatistics = () => {
        const totalSales = tableData.filter(item => item.trans_type === 'Sale')
            .reduce((sum, item) => sum + item.amt, 0);
        const totalPurchases = tableData.filter(item => item.trans_type === 'Purchase')
            .reduce((sum, item) => sum + item.amt, 0);
        const salesCount = tableData.filter(item => item.trans_type === 'Sale').length;
        const purchaseCount = tableData.filter(item => item.trans_type === 'Purchase').length;

        return { totalSales, totalPurchases, salesCount, purchaseCount };
    };

    const stats = getStatistics();

    const columns = [
        {
            name: '#',
            selector: row => row.sl,
            sortable: true,
            width: '70px',
            center: true
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaHashtag size={12} />
                    Transaction ID
                </div>
            ),
            selector: row => row.trans_id,
            sortable: true,
            cell: row => (
                <Badge 
                    color={row.trans_type === 'Sale' ? 'success' : 'primary'} 
                    className="text-white"
                    pill
                >
                    {row.trans_id}
                </Badge>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaShoppingCart size={12} />
                    Type
                </div>
            ),
            selector: row => row.trans_type,
            sortable: true,
            cell: row => (
                <div className="d-flex align-items-center gap-2">
                    {row.trans_type === 'Sale' ? 
                        <FaShoppingBag className="text-success" size={14} /> : 
                        <FaShoppingCart className="text-primary" size={14} />
                    }
                    <span className={row.trans_type === 'Sale' ? 'text-success fw-bold' : 'text-primary fw-bold'}>
                        {row.trans_type}
                    </span>
                </div>
            )
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaCalendarAlt size={12} />
                    Date
                </div>
            ),
            selector: row => row.date,
            sortable: true,
            width: '130px'
        },
        {
            name: (
                <div className="d-flex align-items-center gap-1">
                    <FaRupeeSign size={12} />
                    Amount
                </div>
            ),
            selector: row => row.amt,
            sortable: true,
            cell: row => (
                <div className="fw-bold text-dark">
                    ₹ {row.amt.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </div>
            ),
            right: true
        },
        {
            name: 'Invoice',
            selector: row => row.invoice,
            sortable: false,
            center: true,
            width: '100px'
        },
        {
            name: 'Actions',
            selector: row => row.action,
            sortable: false,
            center: true,
            width: '100px'
        }
    ];

    return (
        <>
            <Header />
            <Page title='Sale & Purchase Management' breadcrumbs='Home / Input Sale Purchase'>
                {mode === 1 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            {/* Enhanced Action Bar */}
                            <Card className='mb-4 border-0 shadow-sm'>
                                <CardBody className="py-3">
                                    <Row className="align-items-center">
                                        <Col lg={6} className="mb-2 mb-lg-0">
                                            <div className="d-flex flex-wrap gap-2">
                                                <Button 
                                                    color='primary' 
                                                    size="sm" 
                                                    onClick={get_sale_purchase_list}
                                                    disabled={loading}
                                                    className="d-flex align-items-center gap-2"
                                                >
                                                    {loading ? (
                                                        <Spinner size="sm" />
                                                    ) : (
                                                        <FaSearch size={14} />
                                                    )}
                                                    {loading ? 'Loading...' : 'Load Transactions'}
                                                </Button>
                                                <Button 
                                                    color='success' 
                                                    size="sm" 
                                                    onClick={() => setMode(2)}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    New Sale
                                                </Button>
                                                <Button 
                                                    color='info' 
                                                    size="sm" 
                                                    onClick={() => setMode(3)}
                                                    className="d-flex align-items-center gap-2 text-white"
                                                >
                                                    <FaPlusCircle size={14} />
                                                    New Purchase
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col lg={6}>
                                            <Row>
                                                <Col md={6} className="mb-2 mb-md-0">
                                                    <InputGroup size="sm">
                                                        <InputGroupText className="bg-light border-end-0">
                                                            <FaFilter className="text-muted" />
                                                        </InputGroupText>
                                                        <Input
                                                            type="select"
                                                            value={filterType}
                                                            onChange={(e) => handleFilterType(e.target.value)}
                                                            className="border-start-0"
                                                        >
                                                            <option value="all">All Types</option>
                                                            <option value="sale">Sales Only</option>
                                                            <option value="purchase">Purchases Only</option>
                                                        </Input>
                                                    </InputGroup>
                                                </Col>
                                                <Col md={6}>
                                                    <InputGroup size="sm">
                                                        <InputGroupText className="bg-light border-end-0">
                                                            <FaSearch className="text-muted" />
                                                        </InputGroupText>
                                                        <Input
                                                            type="search"
                                                            placeholder='Search transactions...'
                                                            value={searchTerm}
                                                            onChange={(e) => handleSearch(e.target.value)}
                                                            className="border-start-0"
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>

                            {/* Statistics Cards */}
                            {tableData.length > 0 && (
                                <Row className="mb-4">
                                    <Col lg={3} md={6} className="mb-3">
                                        <Card className="border-0 bg-gradient-success text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaShoppingBag size={28} className="mb-2 opacity-75" />
                                                <h4 className="mb-1">₹{stats.totalSales.toLocaleString('en-IN')}</h4>
                                                <small className="opacity-75">Total Sales ({stats.salesCount})</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={3} md={6} className="mb-3">
                                        <Card className="border-0 bg-gradient-primary text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaShoppingCart size={28} className="mb-2 opacity-75" />
                                                <h4 className="mb-1">₹{stats.totalPurchases.toLocaleString('en-IN')}</h4>
                                                <small className="opacity-75">Total Purchases ({stats.purchaseCount})</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={3} md={6} className="mb-3">
                                        <Card className="border-0 bg-gradient-info text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaRupeeSign size={28} className="mb-2 opacity-75" />
                                                <h4 className="mb-1">₹{(stats.totalSales - stats.totalPurchases).toLocaleString('en-IN')}</h4>
                                                <small className="opacity-75">Net Profit/Loss</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={3} md={6} className="mb-3">
                                        <Card className="border-0 bg-gradient-warning text-white h-100">
                                            <CardBody className="text-center py-3">
                                                <FaHashtag size={28} className="mb-2 opacity-75" />
                                                <h4 className="mb-1">{tableData.length}</h4>
                                                <small className="opacity-75">Total Transactions</small>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            )}

                            {/* Enhanced Data Table */}
                            <Card className='border-0 shadow-sm'>
                                <CardHeader className="bg-white border-bottom">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-0 text-dark">Transaction Records</h5>
                                            <small className='text-muted'>
                                                {filteredData.length > 0 ?
                                                    `Showing ${filteredData.length} of ${tableData.length} transactions` :
                                                    'No transactions found'
                                                }
                                            </small>
                                        </div>
                                        <div className="d-flex gap-2">
                                            {searchTerm && (
                                                <Badge color="secondary" pill>
                                                    Search: {filteredData.length}
                                                </Badge>
                                            )}
                                            {filterType !== 'all' && (
                                                <Badge color="info" pill>
                                                    {filterType.charAt(0).toUpperCase() + filterType.slice(1)}
                                                </Badge>
                                            )}
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    {tableData.length === 0 && !loading ? (
                                        <Alert color="info" className="m-4 text-center border-0">
                                            <FaShoppingCart size={48} className="mb-3 text-muted opacity-50" />
                                            <h6 className="mb-2">No transactions loaded yet</h6>
                                            <p className="mb-0 text-muted">Click "Load Transactions" to fetch your sale and purchase data</p>
                                        </Alert>
                                    ) : (
                                        <DataTable
                                            title=""
                                            customStyles={{
                                                ...custTableStyles,
                                                headRow: {
                                                    style: {
                                                        backgroundColor: '#f8f9fa',
                                                        borderBottom: '2px solid #dee2e6',
                                                        minHeight: '52px',
                                                    },
                                                },
                                                headCells: {
                                                    style: {
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        color: '#495057',
                                                        padding: '12px 8px',
                                                    },
                                                },
                                                cells: {
                                                    style: {
                                                        fontSize: '13px',
                                                        padding: '12px 8px',
                                                    },
                                                },
                                            }}
                                            columns={columns}
                                            data={filteredData}
                                            highlightOnHover
                                            responsive
                                            pagination
                                            paginationPerPage={10}
                                            paginationRowsPerPageOptions={[10, 25, 50]}
                                            progressPending={loading}
                                            progressComponent={
                                                <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                                    <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                                                    <p className="mt-3 text-muted">Loading transactions...</p>
                                                </div>
                                            }
                                            noDataComponent={
                                                <div className="text-center py-5">
                                                    <FaSearch size={48} className="text-muted mb-3 opacity-50" />
                                                    <h6 className="text-muted">No transactions match your criteria</h6>
                                                    <p className="text-muted mb-0">Try adjusting your search or filter options</p>
                                                </div>
                                            }
                                        />
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}

                {mode === 2 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-gradient-success text-white">
                                    <div className="d-flex align-items-center gap-2">
                                        <FaShoppingBag size={20} />
                                        <h5 className="mb-0">New Sale Entry</h5>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <InputSale back={() => setMode(1)} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}

                {mode === 3 && (
                    <Row className="p-3">
                        <Col xs={12}>
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-gradient-primary text-white">
                                    <div className="d-flex align-items-center gap-2">
                                        <FaShoppingCart size={20} />
                                        <h5 className="mb-0">New Purchase Entry</h5>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <InputPurchase back={() => setMode(1)} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}
            </Page>
            <Footer />

            <style jsx>{`
                .cursor-pointer {
                    cursor: pointer;
                    transition: all 0.2s ease;
                }
                .cursor-pointer:hover {
                    transform: scale(1.1);
                }
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
                }
                .bg-gradient-success {
                    background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
                }
                .bg-gradient-info {
                    background: linear-gradient(135deg, #17a2b8 0%, #117a8b 100%);
                }
                .bg-gradient-warning {
                    background: linear-gradient(135deg, #ffc107 0%, #d39e00 100%);
                }
                .card {
                    transition: all 0.3s ease;
                }
                .card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
                }
            `}</style>
        </>
    );
};

export default InputSalePurchase;